/* eslint-disable import/no-anonymous-default-export */
export default {
  locale: null,

  setLocale(locale) {
    this.locale = locale;
  },
};
